var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nps-main"},[_c('h2',{staticClass:"question f-bold",domProps:{"innerHTML":_vm._s(_vm.question)}}),_c('NPS',{on:{"select":_vm.onSelectScore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }